module.exports = __webpack_public_path__ + "img/wuliuWx.94b28a4f.jpg";